export const PageHero = ({ title, subtitle, image }) => (
  <section className="relative h-[38vh] min-h-[280px] flex items-end">
    <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-[#0B3C5D]/60" />
    <div className="relative max-w-7xl mx-auto w-full px-4 sm:px-6 pb-10">
      <h1 className="font-display text-4xl sm:text-5xl font-bold text-white drop-shadow">{title}</h1>
      <p className="text-slate-100 mt-2 max-w-xl">{subtitle}</p>
    </div>
  </section>
);
